export const checkIsBlankDateChecked = ({ start, end }) => {
  if (!start || !end) return false

  return start === 'CLEAR' && end === 'CLEAR'
}
